import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';
import Switch from '@material-ui/core/Switch';

var styles = function styles(theme) {
  return {
    colorSwitchBase: {
      color: purple[300],
      '&$colorChecked': {
        color: purple[500],
        '& + $colorBar': {
          backgroundColor: purple[500]
        }
      }
    },
    colorBar: {},
    colorChecked: {},
    iOSSwitchBase: {
      '&$iOSChecked': {
        color: theme.palette.common.white,
        '& + $iOSBar': {
          backgroundColor: '#52d869'
        }
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp
      })
    },
    iOSChecked: {
      transform: 'translateX(15px)',
      '& + $iOSBar': {
        opacity: 1,
        border: 'none'
      }
    },
    iOSBar: {
      borderRadius: 13,
      width: 42,
      height: 26,
      marginTop: -13,
      marginLeft: -21,
      border: 'solid 1px',
      borderColor: theme.palette.grey[400],
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    iOSIcon: {
      width: 24,
      height: 24
    },
    iOSIconChecked: {
      boxShadow: theme.shadows[1]
    }
  };
};

var SwitchIOS =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SwitchIOS, _React$Component);

  function SwitchIOS() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SwitchIOS);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SwitchIOS)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      checked: _this.props.checked
    };

    _this.handleChange = function (event) {
      _this.props.onChange(event);

      _this.setState({
        checked: event.target.checked
      });
    };

    return _this;
  }

  _createClass(SwitchIOS, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React.createElement(Switch, {
        classes: {
          switchBase: classes.iOSSwitchBase,
          bar: classes.iOSBar,
          icon: classes.iOSIcon,
          iconChecked: classes.iOSIconChecked,
          checked: classes.iOSChecked
        },
        disableRipple: true,
        checked: this.state.checked,
        onChange: this.handleChange
      });
    }
  }]);

  return SwitchIOS;
}(React.Component);

export default withStyles(styles)(SwitchIOS);